module.exports = __webpack_public_path__ + "static/image/logo-family/logo_kitchen@2x.png?dccc1864";